import { useQuery } from "react-query";
import {
  getOfficeSettings,
  getOfficesFromContext,
} from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";
import { accountAtom } from "modules/Login/atoms/AccountAtom";
import { useRecoilValue } from "recoil";

export const useSFGetOffice = () => {
  const userRoles = useRecoilValue(accountAtom);
  return useQuery("GetSFOffice", getOfficeSettings, {
    refetchOnWindowFocus: false,
    select: (data) => {
      const officeList = !userRoles?.isMexico
        ? data?.filter((x) => !x.country?.toLowerCase().includes("mexico"))
        : data;

      return officeList;
    },
  });
};

export const useGetAllOffices = () => {
  return useQuery("useGetAllOffices", getOfficeSettings, {
    refetchOnWindowFocus: false,
  });
};

export const useGetOfficesFromContext = () => {
  return useQuery("AllOfficeFromContext", getOfficesFromContext, {
    refetchOnWindowFocus: false,
  });
};
